import TabPage from "./../../../factories/tab-page";
import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-toolbar2";
import * as $ from "jquery";
import GenericListSearchTab from "./../../../factories/generic-list-search-tab";
class CategoryOrgUnitTab extends GenericListSearchTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
    }
    SaveAllowed: KnockoutObservable<boolean>;
    SearchType() { return "FolderStructureChecklist"; }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
}
export default CategoryOrgUnitTab;